import { FormlyFieldConfig } from '@ngx-formly/core';
import { LuDatetimePickerPlacement, TimeOptions, TimeOptionsInterface } from 'lu-datetime-picker';
import { LuFormlyBuilder } from './../formly.builder';
import { FieldType } from './formly-builder.models';

export class LuFormlyDateTimeBuilder extends LuFormlyBuilder {
	protected type = FieldType.DATE_TIME;
	private luTimeOptions: TimeOptions;
	private luDateRange = false;
	private placeholderTo: string;
	private minValue: Date;
	private maxValue: Date;
	private primaryRequiredMessage: string;
	private secondaryRequiredMessage: string;
	private hideTimepicker = false;
	private hideDatepicker = false;
	private inlineDatePicker = true;
	private labelDatepicker: string;
	private labelDateRangeTo: string;
	private localeDateTime: boolean;
	private dateOnly: boolean;
	private dateFormat: string;
	private timepickerLabel: string;
	private timepickerLabelTo: string;
	private placement: LuDatetimePickerPlacement;
	private displayClearButton: boolean;

	public setLocaleDateTime(localeDateTime: boolean): this {
		this.localeDateTime = localeDateTime;
		return this;
	}

	public setDateOnly(dateOnly: boolean): this {
		this.dateOnly = dateOnly;
		return this;
	}

	public setLuTimeOptions(luTimeOptions: TimeOptionsInterface): this {
		this.luTimeOptions = new TimeOptions(luTimeOptions);
		return this;
	}

	public setInlineDatePicker(inlineDatePicker: boolean): this {
		this.inlineDatePicker = inlineDatePicker;
		return this;
	}

	public setDatePickerLabel(label: string): this {
		this.labelDatepicker = label;
		return this;
	}

	public setDatePickerLabelTo(label: string): this {
		this.labelDateRangeTo = label;
		return this;
	}

	public setLuDateRange(luDateRange: boolean): this {
		this.luDateRange = luDateRange;
		return this;
	}

	public setPlaceholderTo(placeholderTo: string): this {
		this.placeholderTo = placeholderTo;
		return this;
	}

	public setMinValue(minValue: Date): this {
		this.minValue = minValue;
		return this;
	}

	public setMaxValue(maxValue: Date): this {
		this.maxValue = maxValue;
		return this;
	}

	public setTimepickerLabel(timepickerLabel: string): this {
		this.timepickerLabel = timepickerLabel;
		return this;
	}

	public setTimepickerLabelTo(timepickerLabelTo: string): this {
		this.timepickerLabelTo = timepickerLabelTo;
		return this;
	}

	public setPrimaryRequiredMessage(primaryRequiredMessage: string): this {
		this.primaryRequiredMessage = primaryRequiredMessage;
		return this;
	}

	public setSecondaryRequiredMessage(secondaryRequiredMessage: string): this {
		this.secondaryRequiredMessage = secondaryRequiredMessage;
		return this;
	}

	public setHideTimepicker(hideValue: boolean): this {
		this.hideTimepicker = hideValue;
		return this;
	}

	public setHideDatepicker(hideValue: boolean): this {
		this.hideDatepicker = hideValue;
		return this;
	}

	public setDateFormat(dateFormat: string): this {
		this.dateFormat = dateFormat;
		return this;
	}

	public setPlacement(placement: LuDatetimePickerPlacement): this {
		this.placement = placement;
		return this;
	}

	/**
	 * @description Show reset button
	 */
	public setDisplayClearButton(reset: boolean): this {
		this.displayClearButton = reset;
		return this;
	}

	public build(): FormlyFieldConfig {
		const field = super.build();

		field.templateOptions.luDateRange = this.luDateRange;
		field.templateOptions.luPlaceholderFrom = this.placeholder;
		field.templateOptions.luPlaceholderTo = this.placeholderTo;
		field.templateOptions.luMinValue = this.minValue;
		field.templateOptions.luMaxValue = this.maxValue;
		field.templateOptions.primaryRequiredMessage = this.primaryRequiredMessage;
		field.templateOptions.secondaryRequiredMessage = this.secondaryRequiredMessage;
		field.templateOptions.luTimeOptions = this.luTimeOptions;
		field.templateOptions.luHideTimepicker = this.hideTimepicker;
		field.templateOptions.luHideDatepicker = this.hideDatepicker;
		field.templateOptions.inlineDatePicker = this.inlineDatePicker;
		field.templateOptions.labelDatepicker = this.labelDatepicker;
		field.templateOptions.labelDateRangeTo = this.labelDateRangeTo;
		field.templateOptions.localeDateTime = this.localeDateTime;
		field.templateOptions.dateOnly = this.dateOnly;
		field.templateOptions.dateFormat = this.dateFormat;
		field.templateOptions.labelTimePicker = this.timepickerLabel;
		field.templateOptions.labelTimePickerTo = this.timepickerLabelTo;
		field.templateOptions.placement = this.placement;
		field.templateOptions.displayClearButton = this.displayClearButton;
		return field;
	}
}
